import Base from 'app/routers/base';
import PasswordResetRequestPage from 'app/views/password_reset_request_page';
import PasswordResetPage from 'app/views/password_reset_page';
import ShippingCalculatorPage from 'app/views/shipping_calculator_page';
import LoginView from 'app/views/login_view';
import UserCreateView from 'app/views/user_create_view';
import TalkToEasyPostPage from 'app/views/talk_to_easypost_page';
import VerificationSplashPage from 'app/views/verification_splash_page';
import VerificationSubmitPage from 'app/views/verification_submit_page';
import JobsPage from 'app/views/jobs_page';
import USPSZoneLookupPage from 'app/views/usps_zone_lookup_page';

const DefaultRouter = Base.extend({
  routes: {
    reset: 'requestResetEmail',
    'shipping-calculator': 'calculator',
    signin: 'signin',
    signup: 'signup',
    'talk-to-easypost': 'contact',
    verification: 'verificationSplash',
    jobs: 'jobsPage',
    'jobs.html': 'jobsPage',
    'usps-zone-lookup': 'uspsZoneLookupPage',
  },
  verificationSplash() {
    // we can't have dynamic pages with our static site, so must look for the location hash
    const code = this.checkForHash();
    if (this.enforceNotLoggedIn()) {
      if (code.length) {
        this.renderView(new VerificationSubmitPage({ code }));
      } else {
        this.renderView(new VerificationSplashPage({}));
      }
    }
  },
  contact() {
    this.renderView(new TalkToEasyPostPage({}));
  },
  signup() {
    if (this.enforceNotLoggedIn()) {
      this.renderView(new UserCreateView({}));
    }
  },
  signin() {
    if (this.enforceNotLoggedIn()) {
      this.renderView(new LoginView({}));
    }
  },
  calculator() {
    this.renderView(new ShippingCalculatorPage({}));
  },
  requestResetEmail() {
    const token = this.checkForHash();
    if (this.enforceNotLoggedIn()) {
      if (token.length) {
        this.renderView(new PasswordResetPage({ token }));
      } else {
        this.renderView(new PasswordResetRequestPage({}));
      }
    }
  },
  jobsPage() {
    this.renderView(new JobsPage({}));
  },

  uspsZoneLookupPage() {
    this.renderView(new USPSZoneLookupPage({}));
  },
});

export default DefaultRouter;



// WEBPACK FOOTER //
// ./app/routers/default_router.js